import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const toastOptions = {
  position: "top-center",
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: false,
  draggable: true,
  autoClose: 5000,
};

export const SuccessNotify = (text) => {
  toast.success(text, toastOptions);
};

export const FailedNotify = (faild) => {
  toast.error(faild, toastOptions);
};